import Divider from './Divider';
export default Divider;



// WEBPACK FOOTER //
// ./src/js/Dividers/index.js